import {useEffect,useState} from 'react'
import {envAwarePost} from '../../util/util'
import InputGroup from 'react-bootstrap/InputGroup'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'

const Referral = ({data})=>{
	const [total,setTotal] = useState(data.payout_total)
	const [newTotal,setNewTotal] = useState(data.payout_total)
	const [status,setStatus] = useState('idle')
	const handleEdit = ()=>{
		setStatus('pending')
		envAwarePost('api/referrals',{
			action:'editReferralPayoutTotal',
			total:newTotal,
			id:data.id
		}).then(res=>{
			setStatus('idle')
			if(res.success === '1'){
				setTotal(newTotal)
			}else{
				window.alert(res.message)
			}
		})
	}
	return (
		<div className="border rounded mb-2 d-flex">
			<div className="w-100 p-2">
				<strong>Referrer</strong>: {data.referring_user.user_name} 
				<div>
					<small className="d-block">
						Email: {data.referring_user.user_email}
					</small>
					<small className="d-block">
						Stripe: <span className="text-info">{data.referring_user.customer_payment_id}</span>
					</small>
					<small className="d-block">
						Payout total: <span className="text-success">${(total/100).toFixed(2)}</span>
					</small>
					<div>
						<InputGroup size="sm">
							<InputGroup.Prepend>
								<InputGroup.Text>$</InputGroup.Text>
							</InputGroup.Prepend>
							<Form.Control 
								onChange={ e => {
									const val = parseInt(parseFloat(e.target.value)*100)
									setNewTotal(val)
								}}
								defaultValue={(data.payout_total/100).toFixed(2)}
								placeholder="$XX.XX"
								size="sm"
							/>
							<InputGroup.Append>
								<Button 
									disabled={status==='pending'}
									onClick={handleEdit}
									variant="outline-secondary"
								>
									update total {status==='pending'&&<Spinner animation="border" size="sm"/>}
								</Button>
							</InputGroup.Append>
						</InputGroup>
					</div>
				</div>
			</div>
			<div className="w-100 p-2">
				<strong>Referral</strong>: {data.referred_user.user_name} 
				<div>
					<small className="d-block">
						Email: {data.referred_user.user_email}
					</small>
					<small className="d-block">
						Stripe: <span className="text-info">
							{
								Boolean(data.referred_user.customer_payment_id) ?
								data.referred_user.customer_payment_id :
								'free account'
							}
						</span>
					</small>
					<small className="d-block">
						Value to date: <span className="text-success">${(data.referred_user.value_to_date/100).toFixed(2)}</span>
					</small>
					<small className="d-block">
						Sign up date: {(new Date(data.referred_user?.sign_up_date?.split(' ').join('T'))).toLocaleDateString()}
					</small>
				</div>
			</div>
		</div>
	)
}

const AdminReferrals = ()=>{
	const [list,setList] = useState([])
	const [status,setStatus] =  useState('idle')
	useEffect(()=>{
		setStatus('pending')
		envAwarePost('api/referrals/',{action:'getAllReferrals'}).then((res)=>{
			setStatus('idle')
			setList(res.data.referrals)
		})
	},[])

	return (
		<div>
			<h1>All Referrals</h1>
			<div>
				{
					status === 'pending' ? 
					<div className="text-center">
						<Spinner animation="border"/>
					</div>
					:
					list.map(data=><Referral data={data}/>)
				}
			</div>
		</div>
	)
}

export default AdminReferrals